import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/he-IL.png'
import _imports_1 from '@/assets/icons/en-US.png'
import _imports_2 from '@/assets/icons/ru-RU.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e97353a6")

_pushScopeId("data-v-e97353a6")
const _hoisted_1 = {
  id: "desktop-language-switcher",
  class: "language-switcher-corner"
}
const _hoisted_2 = {
  id: "mobile-language-switcher",
  class: "language-switcher-corner"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "active-locale" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["my-auto", { active: $setup.locale == 'he-IL' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeLang('he-IL')))
        })
      ], 2),
      _createVNode("div", {
        class: ["m-2 my-auto", { active: $setup.locale == 'en-US' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_1,
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeLang('en-US')))
        })
      ], 2),
      _createVNode("div", {
        class: ["my-auto", { active: $setup.locale == 'ru-RU' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_2,
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeLang('ru-RU')))
        })
      ], 2)
    ]),
    _createVNode("div", _hoisted_2, [
      ($setup.openedLocaleBlock)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: { 'active-locale': $setup.locale == 'he-IL' }
            }, [
              _createVNode("img", {
                class: "language-image",
                src: _imports_0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeLang('he-IL')))
              })
            ], 2),
            _createVNode("div", {
              class: ["my-2", { 'active-locale': $setup.locale == 'en-US' }]
            }, [
              _createVNode("img", {
                class: "language-image",
                src: _imports_1,
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeLang('en-US')))
              })
            ], 2),
            _createVNode("div", {
              class: { 'active-locale': $setup.locale == 'ru-RU' }
            }, [
              _createVNode("img", {
                class: "language-image",
                src: _imports_2,
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changeLang('ru-RU')))
              })
            ], 2)
          ]))
        : (_openBlock(), _createBlock("div", {
            key: 1,
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openedLocaleBlock = !$setup.openedLocaleBlock))
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                class: "language-image",
                src: $setup.currentLanguageImage
              }, null, 8, ["src"])
            ])
          ]))
    ])
  ], 64))
})